/**
 * login标签数据接口文档
 */
import { Method } from '../core';
import { API, LOCAL, SOURCE } from '../config';

const api = API;
const local = LOCAL;

export default {
  // 获取用户信息
  info: {
    // url: `${api}/rest/v1/account/info/4095`,
    url: `${api}/rest/v1/account/info/base`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 催签文档
  remindMyDoc: {
    url: `${api}/rest/v1/signflow/remind`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 退回文档
  rejectMyDoc: {
    url: `${api}/rest/v1/signflow/reject`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 撤回文档
  revokeMyDoc: {
    url: `${api}/rest/v1/signflow/revoke`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 更新通知
  update: {
    url: `${api}/rest/v1/alert/set/update`,
    method: Method.PUT,
    body: {
      sms: {
        $type: Boolean
      },
      email: {
        $type: Boolean
      },
      expire: {
        $type: Boolean
      },
      contractExpire: {
        $type: Boolean
      },
      expireTime: {
        $type: Number
      },
      contractExpireTime: {
        $type: Number
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 设置签署密码
  signpwd: {
    url: `${api}/rest/v1/account/signpwd/set`,
    method: Method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 设置登录密码
  loginpwd: {
    url: `${api}/rest/v1/account/loginpwd/set`,
    method: Method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 验证码校验
  codeValidate: {
    url: `${api}/rest/v1/code/validate`,
    method: Method.POST,
    body: {
      code: {
        $type: String
      },
      type: {
        $type: Number
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 验证码校验
  account: {
    url: `${api}/rest/v1/account/account/set`,
    method: Method.PUT,
    body: {
      code: {
        $type: String
      },
      account: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 用户实名信息
  accountInfo: {
    url: `${api}/rest/v1/account/info/19`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 用户实名状态
  status: {
    url: `${api}/rest/v1/account/info/2`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 用户头像信息
  portrait: {
    url: `${api}/rest/v1/account/info/97`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 用户实名 缓存数据 /rest/v1/realname/organ/getCacheInfo?source=esign
  getCacheInfo: {
    url: `${api}/rest/v1/realname/organ/getCacheInfo`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 提交重新认 证验证码  /rest/v1/login/confirm
  confirm: {
    url: `${api}/rest/v1/login/confirm`,
    method: Method.POST,
    body: {
      source: {
        $default: SOURCE
      },
      type: {
        $type: Number
      },
      pwd: {
        $type: String
      }
    }
  },
  // 获取银行信息
  getbankList: {
    url: `${api}/rest/bank/bankList`,
    method: Method.GET,
    body: {
      bankName: {
        $type: String
      }
    }
  },
  // 获取支行信息
  getsubBankList: {
    url: `${api}/rest/bank/subBankList`,
    method: Method.GET,
    body: {
      bankName: {
        $type: String
      },
      provinceCode: {
        $type: String
      },
      cityCode: {
        $type: String
      },
      subBankName: {
        $type: String
      }
    }
  },
  // 获取首页实例 印章
  getExampleSeal: {
    url: `${api}/rest/v1/account/getExampleSeal`,
    method: Method.GET,
    body: {
      source: {
        $default: SOURCE
      }
    }
  },
  // 关闭用户指导
  guideClose: {
    url: `${api}/rest/preferences`,
    method: Method.PUT,
    body: {
      accountUid: {
        $type: String
      },
      name: {
        $type: String
      },
      value: {
        $type: [String, Boolean]
      },
      source: {
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/home.js